import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../../utils/cn";
import { useOverlayLifecycle } from "../_shared/hooks/useOverlayLifecycle";
import { DSOverlayPortal } from "../_shared/ui/DSOverlayPortal";
import { DSOverlayRoot } from "../_shared/ui/DSOverlayRoot";

type DSModalProps = {
  children: ReactNode;
  closeOnOverlayClick?: boolean;
  open: boolean;
  overlayClassName?: string;
  onClose?: () => void;
} & Pick<HTMLAttributes<HTMLDivElement>, "aria-label" | "aria-labelledby"> & {
    className?: string;
  };

function DSModal({
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledby,
  children,
  className,
  closeOnOverlayClick = true,
  open,
  overlayClassName,
  onClose,
}: DSModalProps) {
  useOverlayLifecycle(open, onClose);

  return (
    <DSOverlayPortal open={open}>
      <DSOverlayRoot
        className={cn("flex items-center justify-center", overlayClassName)}
        closeOnOverlayClick={closeOnOverlayClick}
        onClose={onClose}
      >
        <div
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledby}
          aria-modal="true"
          className={cn(
            "w-full max-w-[512px] rounded-3xl bg-body-light-mode-1 shadow-[0_24px_80px_oklch(0.2101_0.0318_264.66_/_0.18)]",
            className
          )}
          role="dialog"
        >
          {children}
        </div>
      </DSOverlayRoot>
    </DSOverlayPortal>
  );
}

export { DSModal };
export type { DSModalProps };
